import Id from '@/models/util/entity/id'

export default class SKUId extends Id {}
